<div class="topo">
    <button class="b-fechar" (click)="close()" mat-icon-button matTooltip="Fechar">
        <mat-icon>close</mat-icon>
    </button>

    <p class="p-titulo" style="font-size: 20px; font-weight: 500;">
        Redefinir sua senha
    </p>
    <br>
    <br>
</div>

<div class="div-body" *ngIf="telaModalR == 0"> <!-- Primeira tela-->
    <div class="div-meio">
        <br>
        <p class="p-titulo">
            Informe o seu login:
        </p>
        <br>

        <form [formGroup]="formUserName">

            <div class="form-group">
                <label class="control-label text-left">
                    Login
                </label>
                <input type="text" formControlName="userName" matInput class="form-control">
            </div>

            <div class="div-botoes">
        
                <button mat-raised-button class="b-proximo" id="botao-proximo" (click)="getUsuario()"> <!-- mudarPainelModal(1) -->
                    Próximo >
                </button>

                <button mat-raised-button class="b-voltar" id="botao-voltar" (click)="close()">
                    < Voltar
                </button>
            </div>

        </form>

    </div>
</div>

<div class="div-body" *ngIf="telaModalR == 1"> <!-- Segunda tela-->
    <div class="div-meio">
        <br>
        <p class="p-titulo">
            Confirme o e-mail abaixo para receber o código de redefinição de senha
        </p>
        <br>

        <div class="input-confirmar">
            <p class="p-subtitulo">
                {{ usuario.emailMascarado }}
            </p>
        </div>
        <br>
        
        <form [formGroup]="formCheck">

            <div class="form-group">
                <label class="control-label text-left">
                    Email
                </label>
                <input type="text" formControlName="checkEmail" matInput class="form-control">

            </div>

            <div id="iderroemail" class="div-erro-email">
                <br>
                <p class="p-subtitulo erro-email">
                    O e-mail que você digitou não está correto. <br>
                </p>
                <p class="p-subtitulo">
                    Por favor, insira seu e-mail novamente ou entre em contato conosco para atualizar suas informações de contato.
                </p>
                <br>
            </div>

            <div class="div-botoes">
        
                <button mat-raised-button class="b-proximo" id="botao-proximo" (click)="compararEmails()"> <!-- mudarPainelModal(2) -->
                    Próximo >
                </button>

                <button mat-raised-button class="b-voltar" id="botao-voltar" (click)="mudarPainelModal(0)">
                    < Voltar
                </button>
            </div>

        </form>
    </div>
</div>

<div class="div-body" *ngIf="telaModalR == 2"> <!-- Terceira tela-->
    <div class="div-meio">
        <br>
        <p class="p-titulo">
            Email enviado
        </p>
        <br>
        <p class="p-subtitulo">
            Acabamos de enviar um código de segurança para o seu e-mail {{ usuario.email }}. <br>
            Use este código para redefinir sua senha.
        </p>
    </div>

    <div class="div-botoes">

        <button mat-raised-button class="b-proximo" id="botao-proximo" (click)="mudarPainelModal(3)"> <!-- mudarPainelModal(3) -->
            Próximo >
        </button>

        <button mat-raised-button class="b-voltar" id="botao-voltar" (click)="mudarPainelModal(1)">
            < Voltar
        </button>
    </div>
</div>

<div class="div-body" *ngIf="telaModalR == 3"> <!-- Quarta tela-->
    <div class="div-meio">
        <br>
        <p class="p-titulo">
            Redefinir Senha
        </p>
        <br>
        
        <form [formGroup]="formNovaSenha" class="form-novaSenha">

            <div class="form-group">
                <label class="control-label text-left">
                    Código de Segurança
                </label>
                <input type="text" formControlName="codSegurança" matInput class="form-control">

            </div>

            <div class="form-group">
                <label class="control-label text-left">
                    Nova Senha
                </label>
                <input type="text" formControlName="novaSenha" matInput class="form-control">

            </div>

            <div class="form-group">
                <label class="control-label text-left">
                    Confirmar Senha
                </label>
                <input type="text" formControlName="confirmarSenha" matInput class="form-control">

            </div>

            <div id="iderrosenhadiferente" class="div-erro-email">
                <br>
                <p class="p-subtitulo erro-email">
                    A nova senha e a confirmação não coincidem. <br>
                </p>
                <p class="p-subtitulo">
                    Certifique-se de que a nova senha e a confirmação sejam idênticas.
                </p>
                <br>
            </div>

            <div class="div-botoes">
        
                <button mat-raised-button class="b-proximo" id="botao-proximo" (click)="redefinirSenha()"> <!-- mudarPainelModal(4) -->
                    Próximo >
                </button>

                <button mat-raised-button class="b-voltar" id="botao-voltar" (click)="mudarPainelModal(2)">
                    < Voltar
                </button>
            </div>

        </form>
    </div>
</div>

<div class="div-body" *ngIf="telaModalR == 4"> <!-- Quinta tela-->
    <div class="div-meio">
        <br>
        <p class="p-titulo">
            Senha redefinada com sucesso
        </p>
    </div>

    <div class="div-botoes">
        <button mat-raised-button class="b-proximo" id="botao-proximo" (click)="close()">
            Ok
        </button>
    </div>
</div>